"use client";

import { useRouter, useSearchParams } from "next/navigation";
import { useCallback } from "react";

type Query = {
  name: string;
  value: string;
};

export const useUpdateQuery = () => {
  const router = useRouter();
  const searchParams = useSearchParams();

  // Get a new searchParams string by merging the current
  // searchParams with a provided key/value pair
  const updateQuery = useCallback(
    ({ name, value }: Query) => {
      const params = new URLSearchParams(searchParams);
      if (value) {
        params.set(name, value);
      } else {
        params.delete(name);
      }

      const hash = window.location.hash;
      router.push(`?${params.toString()}${hash}`, { scroll: false });
    },
    [router, searchParams]
  );

  const updateQueries = useCallback(
    (queries: Query[]) => {
      const params = new URLSearchParams(searchParams);
      queries.forEach(({ name, value }) => {
        if (value) {
          params.set(name, value);
        } else {
          params.delete(name);
        }
      });
      const hash = window.location.hash;
      router.push(`?${params.toString()}${hash}`, { scroll: false });
    },
    [router, searchParams]
  );

  return { updateQuery, updateQueries };
};
